const FLEX_SYSTEM_PROPS = {
  gap: { type: "spacing", property: "gap" },
  rowGap: { type: "spacing", property: "rowGap" },
  columnGap: { type: "spacing", property: "columnGap" },
  align: { type: "default", property: "alignItems" },
  justify: { type: "default", property: "justifyContent" },
  wrap: { type: "default", property: "flexWrap" },
  direction: { type: "default", property: "flexDirection" }
};

export { FLEX_SYSTEM_PROPS };
//# sourceMappingURL=flex-props.js.map
